import React from "react";
import { Link } from "react-router-dom";
import logo from "../../../Images/Body-Soul-LLC.png";

import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaTiktok,
  FaLinkedinIn,
  FaXTwitter,
} from "react-icons/fa6";

const Footer = () => {
  const year = new Date().getFullYear();
  const reseller = JSON.parse(localStorage.getItem("reseller"));

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const linkClass =
    "text-sm font-medium text-white/70 transition-all duration-300 hover:text-white hover:translate-x-1";

  const socialClass =
    "flex h-10 w-10 items-center justify-center rounded-full border border-white/20 bg-white/5 text-base text-white transition-all duration-300 hover:bg-white hover:text-[#0D4B46]";

  return (
    <footer
      className="relative overflow-hidden bg-accent text-white"
      aria-labelledby="footer-heading"
    >
      {/* Background geometric lines */}
      <div className="pointer-events-none absolute inset-0 opacity-20">
        <div className="absolute right-[-120px] top-[-160px] h-[560px] w-[560px] rotate-45 border border-white/30" />
        <div className="absolute right-[180px] top-[120px] h-[360px] w-[360px] rotate-45 border border-white/20" />
        <div className="absolute right-[420px] bottom-[-220px] h-[420px] w-[420px] rotate-45 border border-white/10" />
      </div>

      <div className="relative mx-auto w-[88%] max-w-7xl py-16 lg:py-20">
        <h2 id="footer-heading" className="sr-only">
          Earth Beauty & You - Footer Navigation & Contact Info
        </h2>

        <div className="grid gap-12 sm:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          {/* Brand Section */}
          <div>
            <img
              src={logo}
              alt="Body & Soul LLC Logo"
              className="mb-7 w-[170px]"
            />

            <p className="max-w-sm text-sm leading-6 text-white/80">
              Earth Beauty & You brings carefully selected beauty and skincare
              products for everyday confidence and care.
            </p>

            <div className="mt-7 flex flex-wrap gap-3">
              <a
                href="https://www.facebook.com/EarthBeautyandYou"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow us on Facebook"
                className={socialClass}
              >
                <FaFacebookF />
              </a>

              <a
                href="https://www.instagram.com/earthbeautyandyou/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow us on Instagram"
                className={socialClass}
              >
                <FaInstagram />
              </a>

              <a
                href="https://www.youtube.com/@earthbeautyandyou"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Subscribe to our YouTube channel"
                className={socialClass}
              >
                <FaYoutube />
              </a>

              <a
                href="https://www.tiktok.com/@earthbeautyandyou"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow us on TikTok"
                className={socialClass}
              >
                <FaTiktok />
              </a>

              <a
                href="https://www.linkedin.com/company/earth-beauty-and-you/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow us on LinkedIn"
                className={socialClass}
              >
                <FaLinkedinIn />
              </a>

              <a
                href="https://x.com/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow us on X"
                className={socialClass}
              >
                <FaXTwitter />
              </a>
            </div>

            <button
              onClick={scrollToTop}
              className="mt-8 border border-white/30 px-5 py-3 text-xs font-semibold uppercase tracking-widest transition-all duration-300 hover:bg-white hover:text-[#0D4B46]"
            >
              ↑ Back To Top
            </button>
          </div>

          {/* Site Map */}
          <nav aria-label="Site Map" className="flex flex-col gap-3">
            <h3 className="mb-3 text-sm font-bold uppercase tracking-wider text-white">
              Site Map
            </h3>

            <Link to="/" className={linkClass}>
              Homepage
            </Link>
            <Link to="/about" className={linkClass}>
              About Us
            </Link>
            <Link to="/newarrivals" className={linkClass}>
              New Arrivals
            </Link>
            <Link to="/product-category/face wash" className={linkClass}>
              Face Wash
            </Link>
            <Link to="/product-category/lotion" className={linkClass}>
              Lotion
            </Link>
            <Link to="/product-category/mist toner" className={linkClass}>
              Mist Toner
            </Link>
            <Link to="/product-category/oil" className={linkClass}>
              Oil
            </Link>
            <Link to="/product-category/hand wash" className={linkClass}>
              Hand Wash
            </Link>
          </nav>

          {/* Customer Care */}
          <nav aria-label="Customer Care" className="flex flex-col gap-3">
            <h3 className="mb-3 text-sm font-bold uppercase tracking-wider text-white">
              Customer Care
            </h3>

            <Link to="/refund" className={linkClass}>
              Refund & Return Policy
            </Link>
            <Link to="/shippingPolicy" className={linkClass}>
              Shipping Policy
            </Link>
            <Link to="/privacyPolicy" className={linkClass}>
              Privacy Policy
            </Link>
            <Link to="/terms" className={linkClass}>
              Terms of Service
            </Link>
            <Link to="/distributor-enlishment" className={linkClass}>
              Distributor Enlistment
            </Link>

            {/* <Link
              to={reseller ? "/reseller-dashboard" : "/reseller-login"}
              className={linkClass}
            >
              {reseller ? "Reseller Dashboard" : "Become a Reseller"}
            </Link> */}

            <a
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Download Earth Beauty Catalogue PDF"
              href="https://drive.google.com/file/d/1gb1mMfxNfg8qcESwyukG4M01vXnt5rk2/view?usp=sharing"
              className="mt-4 inline-flex w-fit items-center justify-center rounded border border-white/30 px-4 py-2 text-xs font-semibold uppercase tracking-wider text-white transition-all duration-300 hover:bg-white hover:text-[#0D4B46]"
            >
              Download Catalogue
            </a>
          </nav>

          {/* Legal / Contact */}
          <div className="flex flex-col gap-3">
            <h3 className="mb-3 text-sm font-bold uppercase tracking-wider text-white">
              Legal
            </h3>

            <Link to="/privacyPolicy" className={linkClass}>
              Privacy Policy
            </Link>
            <Link to="/terms" className={linkClass}>
              Terms of Service
            </Link>
            <Link to="/refund" className={linkClass}>
              Refund Policy
            </Link>
            <Link to="/shippingPolicy" className={linkClass}>
              Shipping Policy
            </Link>

            <div className="mt-6">
              <h3 className="mb-4 text-sm font-bold uppercase tracking-wider text-white">
                Contact Us
              </h3>

              <div className="space-y-3 text-sm font-medium text-white/75">
                <p>
                  Email:{" "}
                  <a
                    href="mailto:care@earthbeautyandyou.com"
                    className="transition hover:text-white"
                  >
                    care@earthbeautyandyou.com
                  </a>
                </p>

                <p>
                  Phone:{" "}
                  <a
                    href="tel:+8801404403965"
                    className="transition hover:text-white"
                  >
                    +8801 404 403 965
                  </a>
                </p>

                <p>
                  International:{" "}
                  <a
                    href="mailto:imtiazazhz@gmail.com"
                    className="transition hover:text-white"
                  >
                    imtiazazhz@gmail.com
                  </a>
                </p>

                <p>
                  Influencers:{" "}
                  <a
                    href="mailto:niloygvi@gmail.com"
                    className="transition hover:text-white"
                  >
                    niloygvi@gmail.com
                  </a>
                </p>
              </div>
            </div>

            <div className="mt-6 text-sm font-semibold leading-relaxed text-white/80">
              <p>Under License</p>
              <p>Body & Soul LLC</p>
              <p>16192 Coastal Highway Lewes, Delaware 19958</p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Copyright */}
      <div className="relative border-t border-white/10 py-6 text-center text-sm font-medium text-white/70">
        © {year} Earth Beauty & You – All Rights Reserved
      </div>

      {/* Structured Data for SEO */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "Earth Beauty & You",
          url: "https://earthbeautyandyou.com",
          logo: "https://earthbeautyandyou.com/logo.png",
          sameAs: [
            "https://www.facebook.com/EarthBeautyandYou",
            "https://www.instagram.com/earthbeautyandyou/",
            "https://www.youtube.com/@earthbeautyandyou",
            "https://www.tiktok.com/@earthbeautyandyou",
            "https://www.linkedin.com/company/earth-beauty-and-you/",
            "https://x.com/",
          ],
          contactPoint: [
            {
              "@type": "ContactPoint",
              telephone: "+8801404403965",
              contactType: "Customer Service",
              areaServed: "BD",
              availableLanguage: ["en", "bn"],
            },
          ],
        })}
      </script>
    </footer>
  );
};

export default Footer;